// src/routers/RouteGuard.js
import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { hasPagePermission, isAllowedByDesignedMenu } from '../utils/accessControl';

function useGateDecision() {
  const loc = useLocation();
  const perms = (() => {
    try {
      return JSON.parse(localStorage.getItem('permissions') || '[]');
    } catch {
      return [];
    }
  })();

  return hasPagePermission(perms, [], loc.pathname) && isAllowedByDesignedMenu(loc.pathname);
}

// يلفّ children (لو حبيت تستخدمه كـ HOC)
export default function RouteGuard({ children }) {
  const allowed = useGateDecision();
  return allowed ? children : <Navigate to="/No-access" replace />;
}

// للاستخدام داخل الراوتر كعنصر وسيط
export function RouteGuardOutlet() {
  const allowed = useGateDecision();
  return allowed ? <Outlet /> : <Navigate to="/No-access" replace />;
}
